/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The cost of some or all of a shift.
 * @export
 * @interface ShiftCost
 */
export interface ShiftCost {
    /**
     * 
     * @type {number}
     * @memberof ShiftCost
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ShiftCost
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof ShiftCost
     */
    employeePayDetailId: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ShiftCost
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ShiftCost
     */
    endTime: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ShiftCost
     */
    hourlyRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShiftCost
     */
    cost: number | null;
}

/**
 * Check if a given object implements the ShiftCost interface.
 */
export function instanceOfShiftCost(value: object): value is ShiftCost {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('employeePayDetailId' in value) || value['employeePayDetailId'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('hourlyRate' in value) || value['hourlyRate'] === undefined) return false;
    if (!('cost' in value) || value['cost'] === undefined) return false;
    return true;
}

export function ShiftCostFromJSON(json: any): ShiftCost {
    return ShiftCostFromJSONTyped(json, false);
}

export function ShiftCostFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShiftCost {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'employeePayDetailId': json['employeePayDetailId'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (json['endTime'] == null ? null : new Date(json['endTime'])),
        'hourlyRate': json['hourlyRate'],
        'cost': json['cost'],
    };
}

  export function ShiftCostToJSON(json: any): ShiftCost {
      return ShiftCostToJSONTyped(json, false);
  }

  export function ShiftCostToJSONTyped(value?: ShiftCost | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'employeePayDetailId': value['employeePayDetailId'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': (value['endTime'] == null ? null : (value['endTime'] as any).toISOString()),
        'hourlyRate': value['hourlyRate'],
        'cost': value['cost'],
    };
}

